import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Parallax } from 'react-parallax';
import Navigation from './Navigation';
import Footer from '../components/Footer';

import data from '../data/data.json';

class ClientsPage extends Component {
  constructor() {
    super();
    this.state = {
      navigation: data.navigation,
      footer: data.footer,
      data: data.clients,
    };
  }

  render() {
    return (
      <div>
        <Navigation navigation={this.state.navigation} />
        <section id="about" style={{ paddingTop: 0 }}>
          <Parallax blur={0} bgImage={this.state.data.img} bgImageAlt={this.state.data.title} strength={120}>
            <div style={{ height: '300px' }} />
          </Parallax>
          <div className="container pb-2">
            <div className="row">
              <h1
                className="display-1 hidden-down pt-2"
                style={this.state.data.title.length > 30 ? { fontSize: '4.5em' } : { fontSize: '5em' }}
              >
                {this.state.data.title}
              </h1>
              <div className="col-xl-4 col-lg-4 col-md-5 pt-2 pb-2" />
            </div>

            {/* <div className="carousel-item active flex-column flex-sm-row align-items-stretch"> */}
            <div className="row">
              {this.state.data.clientsList.map((client, i) => (
                <div className="col-md-4 mb-2" key={client.title}>
                  <div className="card card-default h-100">
                    <div className="card-img-top card-img-top-200 card-zoom">
                      <a href={client.link} target="_blank" rel="noopener noreferrer">
                        <img
                          className="img-fluid mx-auto d-block"
                          src={i % 2 ? '/images/client-02.jpg' : '/images/client-00.jpg'}
                          alt={client.title}
                        />
                      </a>
                    </div>
                    <div className="card-body pt-2 pl-1">
                      {/* <h6 className="small text-wide text-truncate pb-1">{client.country}</h6> */}
                      <h6 className="small text-wide text-truncate pb-1">{client.desc}</h6>
                      <h2>
                        <a href={client.link} target="_blank" rel="noopener noreferrer">
                          {client.title}
                        </a>
                      </h2>
                      {client.appsUsed.map(app => (
                        <span className="badge badge-pill badge-danger m-1" key={app.title}>
                          <Link to={app.link} style={{ color: 'white' }}>
                            {app.title}
                          </Link>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* </div> */}

            {/* <div className="row">
              <Gallery photos={this.state.data.clientsList} onClick={this.openLightbox} />
              <Lightbox
                images={this.state.data.clientsList}
                onClose={this.closeLightbox}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen}
              />
            </div> */}
          </div>
        </section>
        <Footer footer={this.state.footer} />
      </div>
    );
  }
}

export default ClientsPage;



// WEBPACK FOOTER //
// ./src/components/ClientsPage.js